export const IsVerbose = (): boolean => {
    if (window.location.hostname === 'localhost') {
        return true;
    }
    else {
        return localStorage.getItem('verbose') === 'true' ? true : false;
    }
};

export const ConsoleLog = (message?: any, ...optionalParams: any[]): void => {
    if (IsVerbose()) {
        console.log(message, ...optionalParams);
    }
}